<template>
    <form class="lf-form" v-if="GrantForm.initialized">
        <div class="lf-top-section">
            <div class="row">
                <div class="col-lg-8">
                    <h4 class="ml-3 mt-3">{{$t('rapid_response_grant.logical_framework__section_title')}}</h4>
                    <div class="form-group">
                        <textarea class="form-control" name="logical.projectTitle" disabled v-model="GrantForm.title"
                            :error="getError('logical.projectTitle')" v-validate="'required'"
                            :data-vv-as="$t('medium_grant.logical__1_project_title')"
                            :label="$t('medium_grant.logical__1_project_title')"
                            :placeholder="$t('medium_grant.logical__1_project_title')">
                        </textarea>
                    </div>
                    <div class="form-group">
                        <textarea class="form-control" name="technical.organisation"
                            v-model="GrantForm.model.technical.leadApplicantName"
                            :disabled="!GrantForm.isEditable"
                            :error="getError('technical.leadApplicantName')" v-validate="'required'"
                            :data-vv-as="$t('medium_grant.logical__1_organisation')"
                            :label="$t('medium_grant.logical__1_organisation')"
                            :placeholder="$t('medium_grant.logical__1_organisation')">
                        </textarea>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-8">
                    <div class="form-group">
                        <textarea class="form-control" name="logical.generalObjective"
                            v-model="GrantForm.model.logical.generalObjective" :error="getError('logical.generalObjective')"
                            v-validate="'required'"
                            :disabled="!GrantForm.isEditable"
                            :data-vv-as="$t('rapid_response_grant.logical_framework__general_objective_title')"
                            :label="$t('rapid_response_grant.logical_framework__general_objective_title')"
                            :placeholder="$t('rapid_response_grant.logical_framework__general_objective_title')">
                        </textarea>
                    </div>
                    <div class="form-group">
                        <textarea class="form-control" name="logical.specificObjective"
                            v-model="GrantForm.model.logical.specificObjective"
                            :disabled="!GrantForm.isEditable"
                            :error="getError('logical.specificObjective')" v-validate="'required'"
                            :data-vv-as="$t('rapid_response_grant.logical_framework__specific_objective_title')"
                            :label="$t('rapid_response_grant.logical_framework__specific_objective_title')"
                            :placeholder="$t('rapid_response_grant.logical_framework__specific_objective_title')">
                        </textarea>
                    </div>
                </div>
            </div>
        </div>

        <div class="logical-framework">
            <div class="lf-headers">
                <span class="lf-header">
                    {{$t('rapid_response_grant.logical_framework__priorities_for_actions_header_results')}}
                </span>
                <span class="lf-header">
                    {{$t('rapid_response_grant.logical_framework__priorities_for_actions_header_indicators')}}
                </span>
                <span class="lf-header">
                    {{$t('rapid_response_grant.logical_framework__priorities_for_actions_header_targets')}}
                </span>
                <span class="lf-header">
                    {{$t('rapid_response_grant.logical_framework__priorities_for_actions_header_source')}}
                </span>
            </div>
            <div class="lf-results">
                <div class="lf-result" v-for="(resource, index) in GrantForm.model.logical.priorityResources" :key="'resource_' + index">
                    <div class="lf-result-info">
                        <h2 class="lf-result-title">Result {{ index + 1 }}</h2>
                        <p>{{ resource.text }}</p>
                    </div>
                    <div class="lf-result-indicators">
                        <template v-for="(indicator, i_index) in resource.indicators">
                            <div class="lf-result-col lf-box" :key="'indicator_box_1_' + index + '_' + i_index">
                                <h2 class="lf-indicator-title">Indicator {{ index + 1 }}.{{ i_index + 1 }}.</h2>
                                <p>{{ $t(indicator.text) }}</p>
                                <input type="number" class="lf-indicator-value" v-model="indicator.value" disabled />
                                <p class="lf-indicator-reference" v-if="indicator.reference !== ''">Indicator Refrence: {{ indicator.reference }}</p>
                            </div>
                            <div class="lf-result-col lf-box" :key="'indicator_box_2_' + index + '_' + i_index">
                                <h3>Baseline</h3>
                                <div class="lf-baseline">
                                    <span class="lf-baseline-year">{{ indicator.baseline.year }}</span>
                                    <input type="number" class="lf-baseline-value" v-model="indicator.baseline.value" disabled />
                                    <input type="text" class="lf-baseline-text" :title="indicator.baseline.text" v-model="indicator.baseline.text" disabled />
                                </div>
                                <h3>Target</h3>
                                <div class="lf-baseline">
                                    <span class="lf-baseline-year">{{ indicator.target.year }}</span>
                                    <input type="number" class="lf-baseline-value" v-model="indicator.target.value" disabled />
                                    <input type="text" class="lf-baseline-text" :title="indicator.target.text" v-model="indicator.target.text" disabled />
                                </div>
                            </div>
                            <div class="lf-result-col lf-box" :key="'indicator_box_3_' + index + '_' + i_index">
                                <p>{{ indicator.source.text }}</p>
                                <span class="lf-edit-item tim-icons icon-pencil" v-if="GrantForm.isEditable" @click="editIndicator(resource, indicator)"></span>
                                <span class="lf-remove-item tim-icons icon-trash-simple" v-if="GrantForm.isEditable" @click="removeIndicator(resource.indicators, i_index)"></span>
                            </div>
                        </template>
                    </div>
                    <span class="lf-edit-item tim-icons icon-pencil" v-if="GrantForm.isEditable" @click="editResource(resource)"></span>
                    <span class="lf-remove-item tim-icons icon-trash-simple" v-if="GrantForm.isEditable" @click="removeResource(index)"></span>
                    <base-button type="primary" class="lf-add-indicator" v-if="GrantForm.isEditable" @click.native="addResourceIndicator(resource)">+ Add Indicator</base-button>
                </div>
                <base-button type="primary" class="lf-add-result" v-if="GrantForm.isEditable" @click.native="addPriorityResource()">+ Add result</base-button>
            </div>
        </div>

        <modal :show.sync="modalResource.visibility" modalClasses="lf-modal">
            <div class="lf-modal-header">
                <span class="lf-header" v-bind:class="{'lf-selected': modalResource.selectedTab == 0}">
                    {{$t('rapid_response_grant.logical_framework__priorities_for_actions_header_results')}}
                </span>
                <span class="lf-separator"></span>
                <span class="lf-header" v-bind:class="{'lf-selected': modalResource.selectedTab == 1}">
                    {{$t('rapid_response_grant.logical_framework__priorities_for_actions_header_indicators')}}
                </span>
                <span class="lf-separator"></span>
                <span class="lf-header" v-bind:class="{'lf-selected': modalResource.selectedTab == 2}">
                    {{$t('rapid_response_grant.logical_framework__priorities_for_actions_header_targets')}}
                </span>
                <span class="lf-separator"></span>
                <span class="lf-header" v-bind:class="{'lf-selected': modalResource.selectedTab == 3}">
                    {{$t('rapid_response_grant.logical_framework__priorities_for_actions_header_source')}}
                </span>
            </div>
            <div class="lf-modal-content">
                <div class="lf-modal-section" v-if="modalResource.selectedTab == 0">
                    <p class="lf-top">{{ $t('rapid_response_grant.logical_framework__priorities_for_actions_instructions_results') }}</p>
                    <textarea class="lf-modal-textarea" v-model="modalResource.resource.text"></textarea>
                </div>
                <div class="lf-modal-section" v-if="modalResource.selectedTab == 1">
                    <p class="lf-top">{{ $t('rapid_response_grant.logical_framework__priorities_for_actions_instructions_indicators') }}</p>
                    <div class="lf-modal-indicators-holder">
                        <span class="lf-define-indicator">Define your own indicator <button class="btn btn-primary" @click="addCustomIndicator(modalResource.customIndicators)">+</button></span>
                        <div class="lf-modal-indicators lf-modal-custom-indicators" v-if="modalResource.customIndicators.length">
                            <span class="lf-indicator-header">Indicator Text</span>
                            <span class="lf-indicator-header-value">Indicator Value</span>
                            <div class="lf-modal-indicator" v-for="(indicator, index) in modalResource.customIndicators" :key="'custom_id_' + index">
                                <div class="lf-modal-indicator-field">
                                    <input type="text" v-model="indicator.text" />
                                    <button class="btn lf-modal-remove-indicator" @click="removeIndicator(modalResource.customIndicators, index)">-</button>
                                </div>
                                <input type="number" class="lf-modal-indicator-value" placeholder="0" v-model="indicator.value" />
                            </div>
                        </div>
                        <span style="display: block; line-height: 1; margin-left: 5px" v-if="modalResource.customIndicators.length === 0">Or</span>
                        <div class="lf-modal-indicators" v-if="modalResource.customIndicators.length === 0">
                            <span class="lf-indicator-header">Choose Indicators</span>
                            <button class="btn btn-primary" @click="modalResource.selectIndicatorExpanded = true">+</button>
                            <span class="lf-indicator-header-value">Indicator Value</span>
                            <div class="lf-indicator-add-field" v-if="modalResource.selectIndicatorExpanded">
                                <div class="lf-indicator-selector">
                                    <div class="lf-indicator-cat" v-for="(category, key) in availableIndicators" :key="key" v-bind:class="{'lf-expanded': (expandedSelector == key)}">
                                        <span class="lf-indicator-cat-title" @click="expandedSelector = key">{{ category.title }}</span>
                                        <ul class="lf-indicator-items">
                                            <li v-for="(indicator, index) in category.indicators" :key="key + '_' + index" @click="addIndicator(indicator)">{{ $t(indicator.text) }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="lf-modal-indicator" v-else v-for="(indicator, index) in modalResource.indicators" :key="indicator.id">
                                <div class="lf-modal-indicator-field">
                                    <span class="lf-indicator-text-field">{{ $t(indicator.text) }}</span>
                                    <!-- <input type="text" :value="indicator.text" disabled /> -->
                                    <button class="btn lf-modal-remove-indicator" @click="removeIndicator(modalResource.indicators, index)" v-if="index > 0">-</button>
                                </div>
                                <input type="number" class="lf-modal-indicator-value" placeholder="0" v-model="indicator.value" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="lf-modal-section" v-if="modalResource.selectedTab == 2">
                    <p class="lf-top">{{ $t('rapid_response_grant.logical_framework__priorities_for_actions_instructions_baseline') }}</p>
                    <div class="lf-indicator-baseline-holder" v-for="(indicator, index) in resourceIndicators" :key="'indicator_baseline_' + index">
                        <h2>{{ $t(indicator.text) }}</h2>
                        <h3>Baseline</h3>
                        <div class="lf-indicator-baseline">
                            <div class="lf-baseline-header">
                                <span>Select Year</span>
                                <span>Define Value</span>
                                <span>Explain Value</span>
                            </div>
                            <el-select class="lf-indicator-year" placeholder="Select indicator" clearable v-model="indicator.baseline.year">
                                <el-option v-for="item in years" :key="item" :label="item" :value="item"/>
                            </el-select>
                            <input type="number" class="lf-indicator-value" placeholder="0" v-model="indicator.baseline.value" />
                            <input type="text" class="lf-indicator-explain" placeholder="Ex. Publications, maps" v-model="indicator.baseline.text" />
                        </div>
                        <h3>Target</h3>
                        <div class="lf-indicator-baseline">
                            <div class="lf-baseline-header">
                                <span>Select Year</span>
                                <span>Define Value</span>
                                <span>Explain Value</span>
                            </div>
                            <el-select class="lf-indicator-year" placeholder="Select indicator" clearable v-model="indicator.target.year">
                                <el-option v-for="item in years" :key="item" :label="item" :value="item"/>
                            </el-select>
                            <input type="number" class="lf-indicator-value" placeholder="0" v-model="indicator.target.value" />
                            <input type="text" class="lf-indicator-explain" placeholder="Ex. Publications, maps" v-model="indicator.target.text" />
                        </div>
                    </div>
                </div>
                <div class="lf-modal-section" v-if="modalResource.selectedTab == 3">
                    <p class="lf-top">{{ $t('rapid_response_grant.logical_framework__priorities_for_actions_instructions_source') }}</p>
                    <div class="lf-source-holder" v-for="(indicator, index) in resourceIndicators" :key="'indicator_source_' + index">
                        <h2>{{ $t(indicator.text) }}</h2>
                        <textarea class="lf-modal-textarea" v-model="indicator.source.text"></textarea>
                    </div>
                </div>
            </div>
            <div class="lf-modal-footer row">
                <div class="col-8">
                    <base-button type="primary" class="lf-modal-next" @click="modalResource.selectedTab++" v-if="modalResource.selectedTab < (modalResource.tabCount - 1)">Next</base-button>
                    <base-button type="primary" class="lf-modal-next" @click="saveResource(modalResource.existingResource, modalResource.existingIndicator)" v-else>Save</base-button>
                </div>
                <div class="col-4 text-right">
                    <base-button type="danger" @click.native="modalResource.visibility = false">Close</base-button>
                </div>
            </div>
        </modal>
    </form>
</template>
<script>
    import {GrantForm} from "@/services";
    import {Modal} from 'src/components';
    import {Select, Option} from 'element-ui';
    import {TabPane, Tabs} from 'src/components';

    export default {
        components:
        {
            TabPane,
            Tabs,
            Modal,
            [Select.name]: Select,
            [Option.name]: Option,
        },
        data()
        {
            const vm = this;

            return {
                GrantForm,
                years: Array(21).fill(0).map((_, index) => 2010 + index),
                expandedSelector: 'governance',
                availableIndicators: {
                    governance: {
                        title: 'Governance',
                        indicators:
                        [
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_igo_1_1'),
                                reference: 'IGO1.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_1_2'),
                                        reference: 'IGO1.2'
                                    }
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_igo_2_1'),
                                reference: 'IGO2.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_2_2'),
                                        reference: 'IGO2.2'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_2_3'),
                                        reference: 'IGO2.3'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_igo_3_1'),
                                reference: 'IGO3.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_3_2'),
                                        reference: 'IGO3.2'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_igo_4_1'),
                                reference: 'IGO4.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_4_2'),
                                        reference: 'IGO4.2'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_4_3'),
                                        reference: 'IGO4.3'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_4_4'),
                                        reference: 'IGO4.4'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_4_5'),
                                        reference: 'IGO4.5'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_igo_5_1'),
                                reference: 'IGO5.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_5_2'),
                                        reference: 'IGO5.2'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_5_3'),
                                        reference: 'IGO5.3'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_5_4'),
                                        reference: 'IGO5.4'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_igo_6_1'),
                                reference: 'IGO6.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_6_2'),
                                        reference: 'IGO6.2'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_6_3'),
                                        reference: 'IGO6.3'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_igo_7_1'),
                                reference: 'IGO7.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_7_2'),
                                        reference: 'IGO7.2'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_7_3'),
                                        reference: 'IGO7.3'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_7_4'),
                                        reference: 'IGO7.4'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_igo_8_0'),
                                reference: 'IGO8',
                                subindicators: []
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_igo_9_1'),
                                reference: 'IGO9.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_9_2'),
                                        reference: 'IGO9.2'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_9_3'),
                                        reference: 'IGO9.3'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_9_4'),
                                        reference: 'IGO9.4'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_igo_10_1'),
                                reference: 'IGO10.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_10_2'),
                                        reference: 'IGO10.2'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_10_3'),
                                        reference: 'IGO10.3'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_igo_10_4'),
                                        reference: 'IGO10.4'
                                    },
                                ]
                            },
                        ],
                    },
                    management: {
                        title: 'Management',
                        indicators: [
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_im_1_1'),
                                reference: 'IM1.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_1_2'),
                                        reference: 'IM1.2'
                                    }
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_im_2_1'),
                                reference: 'IM2.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_2_2'),
                                        reference: 'IM2.2'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_2_3'),
                                        reference: 'IM2.3'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_2_4'),
                                        reference: 'IM2.4'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_im_3_1'),
                                reference: 'IM3.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_3_2'),
                                        reference: 'IM3.2'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_im_4_1'),
                                reference: 'IM4.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_4_2'),
                                        reference: 'IM4.2'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_im_5_1'),
                                reference: 'IM5.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_5_2'),
                                        reference: 'IM5.2'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_im_6_1'),
                                reference: 'IM6.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_6_2'),
                                        reference: 'IM6.2'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_6_3'),
                                        reference: 'IM6.3'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_im_7_1'),
                                reference: 'IM7.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_7_2'),
                                        reference: 'IM7.2'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_7_3'),
                                        reference: 'IM7.3'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_im_8_1'),
                                reference: 'IM8.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_8_2'),
                                        reference: 'IM8.2'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_8_3'),
                                        reference: 'IM8.3'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_8_4'),
                                        reference: 'IM8.4'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_im_9_1'),
                                reference: 'IM9.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_9_2'),
                                        reference: 'IM9.2'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_im_10_1'),
                                reference: 'IM10.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_10_2'),
                                        reference: 'IM10.2'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_im_11_1'),
                                reference: 'IM11.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_11_2'),
                                        reference: 'IM11.2'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_11_3'),
                                        reference: 'IM11.3'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_im_12_1'),
                                reference: 'IM12.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_12_2'),
                                        reference: 'IM12.2'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_im_13_1'),
                                reference: 'IM13.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_13_2'),
                                        reference: 'IM13.2'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_im_14_1'),
                                reference: 'IM14.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_14_2'),
                                        reference: 'IM14.2'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_14_3'),
                                        reference: 'IM14.3'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_14_4'),
                                        reference: 'IM14.4'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_14_5'),
                                        reference: 'IM14.5'
                                    },
                                ]
                            },
                            {
                                text: ('rapid_response_grant.logical_framework__indicator_im_15_1'),
                                reference: 'IM15.1',
                                subindicators: [
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_15_2'),
                                        reference: 'IM15.2'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_15_3'),
                                        reference: 'IM15.3'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_15_4'),
                                        reference: 'IM15.4'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_15_5'),
                                        reference: 'IM15.5'
                                    },
                                    {
                                        text: ('rapid_response_grant.logical_framework__indicator_im_15_6'),
                                        reference: 'IM15.6'
                                    },
                                ]
                            },
                        ]
                    }
                },
                modalResource:
                {
                    visibility: false,
                    existingResource: false,
                    existingIndicator: false,
                    editingResource: false,
                    selectIndicatorExpanded: false,
                    selectedTab: 0,
                    tabCount: 4,
                    resource: {},
                    indicator: {},
                    customIndicators: [],
                    indicators: []
                }
            }
        },
        computed:
        {
            resourceIndicators()
            {
                const vm = this;

                return vm.modalResource.indicators.concat(vm.modalResource.customIndicators);
            },
        },
        beforeMount()
        {
            if (!GrantForm.model.logical.priorityResources)
            {
                GrantForm.model.logical.priorityResources = [];
            }
        },
        methods: {
            getError(fieldName) {
                return this.errors.first(fieldName);
            },
            validate() {
                return this.$validator.validateAll().then(res => {
                    this.$emit('on-validated', res, this.model);
                    return res;
                });
            },
            addPriorityResource()
            {
                const vm = this;

                vm.modalResource.resource = {
                    text: '',
                    indicators: []
                };

                vm.modalResource.indicator = {
                    text: '',
                    value: 0,
                    reference: '',
                    baseline:
                    {
                        year: '2020',
                        value: 0,
                        text: ''
                    },
                    target:
                    {
                        year: '2020',
                        value: 0,
                        text: ''
                    },
                    source:
                    {
                        text: ''
                    }
                };

                vm.modalResource.selectedTab = 0;
                vm.modalResource.existingResource = false;
                vm.modalResource.editingResource = false;
                vm.modalResource.visibility = true;

                // this.$forceUpdate();
            },
            addResourceIndicator(resource)
            {
                const vm = this;

                vm.modalResource.indicator = {
                    text: '',
                    value: 0,
                    reference: '',
                    baseline:
                    {
                        year: '2020',
                        value: 0,
                        text: ''
                    },
                    target:
                    {
                        year: '2020',
                        value: 0,
                        text: ''
                    },
                    source:
                    {
                        text: ''
                    }
                };

                vm.modalResource.resource = resource;
                vm.modalResource.selectedTab = 1;
                vm.modalResource.existingResource = true;
                vm.modalResource.visibility = true;
                vm.modalResource.indicators = [];
                vm.modalResource.customIndicators = [];

                // this.$forceUpdate();
            },
            addIndicator(indicator)
            {
                const vm = this;

                vm.modalResource.indicators = [];

                vm.modalResource.indicators.push({
                    customIndicator: false,
                    text: indicator.text,
                    value: 0,
                    reference: indicator.reference,
                    baseline:
                    {
                        year: '2020',
                        value: 0,
                        text: ''
                    },
                    target:
                    {
                        year: '2020',
                        value: 0,
                        text: ''
                    },
                    source:
                    {
                        text: ''
                    }
                });

                for (var i = 0; i < indicator.subindicators.length; i++)
                {
                    let subindicator = indicator.subindicators[i];

                    vm.modalResource.indicators.push({
                        customIndicator: false,
                        text: subindicator.text,
                        value: 0,
                        reference: subindicator.reference,
                        baseline:
                        {
                            year: '2020',
                            value: 0,
                            text: ''
                        },
                        target:
                        {
                            year: '2020',
                            value: 0,
                            text: ''
                        },
                        source:
                        {
                            text: ''
                        }
                    });
                }

                vm.modalResource.selectIndicatorExpanded = false;
            },
            addCustomIndicator(indicators)
            {
                indicators.push({
                    customIndicator: true,
                    text: '',
                    value: 0,
                    reference: '',
                    baseline:
                    {
                        year: '2020',
                        value: 0,
                        text: ''
                    },
                    target:
                    {
                        year: '2020',
                        value: 0,
                        text: ''
                    },
                    source:
                    {
                        text: ''
                    }
                });
            },
            editIndicator(resource, indicator)
            {
                const vm = this;

                vm.modalResource.indicator = indicator;
                vm.modalResource.resource = resource;
                vm.modalResource.selectedTab = 1;
                vm.modalResource.existingResource = true;
                vm.modalResource.existingIndicator = true;
                vm.modalResource.visibility = true;
                vm.modalResource.indicators = [];
                vm.modalResource.customIndicators = [];

                if (indicator.customIndicator)
                {
                    vm.modalResource.customIndicators.push(indicator);
                }
                else
                {
                    vm.modalResource.indicators.push(indicator);
                }
            },
            removeIndicator(indicators, index)
            {
                if (confirm('Are you sure you want to remove this indicator?'))
                {
                    indicators.splice(index, 1);
                }
            },
            editResource(resource)
            {
                const vm = this;

                // vm.modalResource.indicator = indicator;
                vm.modalResource.resource = resource;
                vm.modalResource.selectedTab = 0;
                vm.modalResource.existingResource = true;
                vm.modalResource.editingResource = true;
                vm.modalResource.existingIndicator = false;
                vm.modalResource.visibility = true;
                vm.modalResource.indicators = [];
                vm.modalResource.customIndicators = [];

                resource.indicators.forEach(function (indicator)
                {
                    if (indicator.customIndicator)
                    {
                        vm.modalResource.customIndicators.push(indicator);
                    }
                    else
                    {
                        vm.modalResource.indicators.push(indicator);
                    }
                });
            },
            removeResource(index)
            {
                if (confirm('Are you sure you want to remove this resource?'))
                {
                    GrantForm.model.logical.priorityResources.splice(index, 1);
                }
            },
            saveResource(existingResource, existingIndicator)
            {
                const vm = this;

                if (!existingIndicator && !vm.modalResource.editingResource)
                {
                    if (existingResource)
                    {
                        vm.modalResource.resource.indicators = vm.modalResource.resource.indicators.concat(vm.modalResource.indicators, vm.modalResource.customIndicators);
                    }
                    else
                    {
                        vm.modalResource.resource.indicators = vm.modalResource.resource.indicators.concat(vm.modalResource.indicators, vm.modalResource.customIndicators);
                        GrantForm.model.logical.priorityResources.push(vm.modalResource.resource);
                    }
                }

                vm.modalResource.visibility = false;
            },
        }
    }

</script>
<style lang="scss" scoped>
    .table-bordered td,
    .table-bordered th {
        padding: 20px;
    }

    .lf-top-section
    {
        border: 1px solid #000;
        margin-bottom: 10px;
    }

</style>
